module.exports = __webpack_public_path__ + "6708e409bf33ef845792c67d9ae961ac.png";